import clsx from "clsx";
import styles from "./styles.module.scss";

interface ControlsBarProps {
  isLoading?: boolean;
}

export function ControlsBar({
  isLoading,
  children,
}: React.PropsWithChildren<ControlsBarProps>) {
  return (
    <div
      className={clsx(styles.container, {
        [styles["container-loading"]]: isLoading,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.top}>
          <p className={styles.title}>Data filters</p>
          {isLoading ? (
            <div className={styles.loading}>
              <div className={styles.spinner} role="status">
                <div className={styles.hide}>Loading...</div>
              </div>
            </div>
          ) : null}
        </div>
        <fieldset className={styles.controls}>{children}</fieldset>
      </div>
    </div>
  );
}
